module.exports = __webpack_public_path__ + "ddeef6abbb94931f6fb994fe4a83aa0a.png";